import React from "react";
import { FleetrifyModal } from "../../Modal/modal";
import { FleetrifyButton } from "../../Button/customButton";

const DeactivateCompanyBranchModal = ({
  isModalOpen,
  setIsModalOpen,
}: {
  isModalOpen: boolean;
  setIsModalOpen: (param: boolean) => void;
}) => {
  return (
    <FleetrifyModal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      className="max-w-2xl h-auto"
    >
      <div className="space-y-5 px-10">
        <h1 className="text-[#00032A] text-[20px] font-bold">Deactivate</h1>
        <p className="text-[#00032A] ">
          This will stop operations for the selected branches.
        </p>

        <div className="space-x-3 pt-5">
          <FleetrifyButton
            onClick={() => setIsModalOpen(false)}
            className="border !py-[10px] border-[#EB5757] bg-[#EB575733] text-[#EB5757] hover:bg-red-200"
          >
            Cancel
          </FleetrifyButton>
          <FleetrifyButton className=" bg-[#EB5757] !py-[11px] text-white hover:bg-red-600">
            Deactivate
          </FleetrifyButton>
        </div>
      </div>
    </FleetrifyModal>
  );
};

export default DeactivateCompanyBranchModal;
